<template>
  <div>
    <div class="about-header">
      <div class="about-menu">
        <div class="about-menu-contents">
          <a aria-label="Home" href="/promo"><div class="logo"></div></a>
          <ul>
            <li><a href="/promo">APP FEATURES</a></li>
            <li><a href="/blog">BLOG</a></li>
            <li><a href="/about">ABOUT</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="about-header-mobile">
      <div class="logo-holder">
        <div class="logo"></div>
        <p @click="toggleSmallMenu()">MENU</p>
        <div class="small-menu" v-if="showSmallMenu">
          <ul>
            <li><a href="/">APP FEATURES</a></li>
            <li><a href="/blog">BLOG</a></li>
            <li><a href="/about">ABOUT</a></li>
          </ul>
        </div>
      </div>
      <div class="about-mobile-image"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutHeader',

  props: {
    title: {
      default: ''
    },
    icon: {
      default: ''
    },
  },

  data() {
    return {
      showSmallMenu: false,
    }
  },

  methods: {
    toggleSmallMenu() {
      this.showSmallMenu = !this.showSmallMenu;
    }
  },

  computed: {
    userName() {
      return this.$store.state.users.user.email;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.about-header {
  display: none;
  background-image: url(~@/assets/subpage-header-1.webp);
  height: 480px;
  background-position: center;
  background-size: cover;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.25);

  .about-menu {
    width: 506px;
    height: 480px;
    background: linear-gradient(229.61deg, #0E0F15 0%, #0D1D31 100.96%, #0D1D31 100.96%);
    transform: skewX(-17.5deg);
    margin-left: -100px;

    .about-menu-contents {
      transform: skewX(17.5deg);
      overflow: hidden;
      
      .logo {
        width: 280px;
        height: 120px;
        background-image: url(~@/assets/wotive-logo.png);
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        margin: auto;
        margin-top: 40px;
      }

      ul {
        display: flex;
        flex-direction: column;
        text-align: center;
        padding: 0;
        color: #FFF;
        font-weight: bold;
        font-size: 18px;
        list-style: none;

        li {
          margin-bottom: $spacing-base;
          cursor: pointer;
          user-select: none;

          a {
            color: #FFF;
            text-decoration: none;
          }
        }
      }
    }
  }
}

.about-header-mobile {
  .logo-holder {
    background: $sec0;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    padding-bottom: $spacing-base;

    .logo {
      width: 280px;
      height: 120px;
      background-image: url(~@/assets/wotive-logo.png);
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      margin: auto;
    }

    p {
      color: $sec4;
      font-weight: bold;
      font-size: 14px;
      cursor: pointer;
      text-align: center;
    }
  }

  .about-mobile-image {
    width: 100%;
    height: 120px;
    background-image: url(~@/assets/subpage-header-1-mobile.webp);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;      
  }

  .small-menu {

    ul {
      list-style: none;
      padding: 0;
      text-align: center;

      li {
        padding-bottom: 8px;
      }

      a {
        color: #FFF;
        text-decoration: none;
      }
    }
  }
}

@media all and (min-width: 650px) {
  .about-header {
    display: block;
  }

  .about-header-mobile {
    display: none;
  }
}
</style>